<template>
  <div>
    <div class="columns is-mobile is-multiline">
      <div class="column is-full">
        <window title="404">
          <error-404></error-404>
        </window>
      </div>
      <div class="column is-full">
        <window title="500">
          <error-500></error-500>
        </window>
      </div>
    </div>
  </div>
</template>

<script>
import error404 from '@/components/errors/Error404.vue';
import error500 from '@/components/errors/Error500.vue';

export default {
  components: { error404, error500 },
};
</script>

